import { Button, Form } from "antd";
import { FormComponentProps } from "antd/lib/form";
import * as React from "react";
import { Report7ParamBoxConstants } from "../../../../common/Constants";
import { IFormStructureSection } from "../../../../model/report/applicantdata/FormStructureSection";
import { IFormTypeItem } from "../../../../model/report/FormTypeItem";
import { IReport6Applicant } from "../../../../model/report/Report6Applicant";
import { IReportingPeriodItem } from "../../../../model/report/ReportingPeriodItem";
import { IReport7Params } from "../../../../presenter/report/Report7Presenter";
import { TTranslate } from "../../../../service/locale/TranslationService";
import MultiSelect from "../../app/MultiSelect";
import SelectInput from "../../app/SelectInput";
import TreeMultiSelect from "../../app/TreeMultiSelect";

export interface State {}

export interface Report7ParamBoxProps extends FormComponentProps {
  translate: TTranslate;
  reportingPeriods: IReportingPeriodItem[];
  onReportingPeriodChange(reportingPeriodId?: number): void;
  applicants: IReport6Applicant[];
  onApplicantsSearch(fullName: string): void;
  onApplicantsChange(selectedApplicantIds: string[]): void;
  formTypes: IFormTypeItem[];
  isFormTypesSelectDisabled: boolean;
  onChangeFormType(formTypeCode: string): void;
  formStructure: IFormStructureSection[];
  onSubmit(params: IReport7Params): void;
  reportLoader?: boolean;
}

class Report5ParamBox extends React.Component<Report7ParamBoxProps, State> {
  render() {
    const {
      translate,
      reportingPeriods,
      onReportingPeriodChange,
      applicants,
      onApplicantsSearch,
      onApplicantsChange,
      formTypes,
      isFormTypesSelectDisabled,
      onChangeFormType,
      formStructure,
      onSubmit,
      reportLoader
    } = this.props;

    const { getFieldDecorator } = this.props.form;

    const submitForm = (e: React.MouseEvent) => {
      e.preventDefault();
      this.props.form.validateFields((err, values) => {
        if (!err) {
          const params: IReport7Params = {
            ...values,
            reportingPeriodId: Number.parseInt(values.reportingPeriodId),
            applicantIds: values.applicantIds.map((applicantId: string) => {
              return Number.parseInt(applicantId);
            })
          };
          onSubmit(params);
        }
      });
    };
    return (
      <div className={"report-sidebar"}>
        <Form>
          <Form.Item
            label={
              <span style={{ fontSize: 14 }}>
                {translate("report7_param_box.reporting_period")}
              </span>
            }
          >
            {getFieldDecorator(Report7ParamBoxConstants.REPORTING_PERIOD_ID, {
              rules: [
                {
                  required: true,
                  message: translate("report7_param_box.required_message", {
                    field: translate("report7_param_box.reporting_period")
                  })
                }
              ]
            })(
              <SelectInput
                placeholder={translate(
                  "report7_param_box.choose_reporting_period"
                )}
                selectOptions={reportingPeriods}
                selectOptionKey={"id"}
                selectOptionValue={"name"}
                style={{ width: "100%", minWidth: 200 }}
                onChange={(reportingPeriodId) =>
                  reportingPeriodId
                    ? onReportingPeriodChange(parseInt(reportingPeriodId, 10))
                    : onReportingPeriodChange(undefined)
                }
                defaultActiveFirstOption={false}
                allowClear={true}
                showSearch={true}
                notFoundContent={translate("search.no_data")}
              />
            )}
          </Form.Item>
          <Form.Item
            label={
              <span style={{ fontSize: 14 }}>
                {translate("report7_param_box.applicants")}
              </span>
            }
          >
            {getFieldDecorator(Report7ParamBoxConstants.APPLICANT_IDS, {
              rules: [
                {
                  required: true,
                  message: translate("report7_param_box.required_message", {
                    field: translate("report7_param_box.applicants")
                  })
                }
              ]
            })(
              <MultiSelect
                mode={"multiple"}
                options={applicants}
                selectOptionKey={"id"}
                selectOptionValue={"fullName"}
                onChange={onApplicantsChange}
                placeholder={translate(
                  "report7_param_box.applicants_placeholder"
                )}
                notFoundContent={translate("search.no_data")}
                onSearch={(value) => onApplicantsSearch(value)}
                style={{ width: "100%", minWidth: 200 }}
              />
            )}
          </Form.Item>
          <Form.Item
            label={
              <span style={{ fontSize: 14 }}>
                {translate("report7_param_box.form_type")}
              </span>
            }
          >
            {getFieldDecorator(Report7ParamBoxConstants.FORM_TYPE_CODE, {
              rules: [
                {
                  required: true,
                  message: translate("report7_param_box.required_message", {
                    field: translate("report7_param_box.form_type")
                  })
                }
              ]
            })(
              <SelectInput
                disabled={isFormTypesSelectDisabled || false}
                placeholder={translate("report7_param_box.form_type")}
                selectOptions={formTypes}
                selectOptionKey={"code"}
                selectOptionValue={"name"}
                style={{ width: "100%", minWidth: 200 }}
                onChange={(value) => onChangeFormType(value)}
                defaultActiveFirstOption={false}
                showSearch={true}
                notFoundContent={translate("search.no_data")}
                allowClear={true}
              />
            )}
          </Form.Item>
          <Form.Item
            label={
              <span style={{ fontSize: 14 }}>
                {translate("report7_param_box.form_structure")}
              </span>
            }
          >
            {getFieldDecorator(
              Report7ParamBoxConstants.SELECTED_FORM_STRUCTURE_SECTION_FULLNAMES,
              {
                rules: [
                  {
                    required: true,
                    message: translate("report7_param_box.required_message", {
                      field: translate("report7_param_box.form_structure")
                    })
                  }
                ]
              }
            )(
              <TreeMultiSelect
                options={formStructure}
                childrenKey={"formStructureSections"}
                titleProp={"fullName"}
                keyProp={"fullName"}
                valueProp={"fullName"}
                checkableProp={"isSelectable"}
                style={{ width: "100%", minWidth: 200 }}
                noOptionsMsg={translate("search.no_data")}
              />
            )}
          </Form.Item>
          <Form.Item>
            <Button
              type={"primary"}
              onClick={submitForm}
              loading={reportLoader || false}
            >
              {translate("report7_param_box.generate")}
            </Button>
          </Form.Item>
        </Form>
      </div>
    );
  }
}

export default Form.create<Report7ParamBoxProps>({})(Report5ParamBox);
